// src/pages/public/Services.js
import React from "react";
import { Helmet } from 'react-helmet-async';
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { SHOP_SERVICES, COMPANY, MAYA_FEES } from "../../utils/constants";


export default function Services() {
  <Helmet>
    <title>Web Development Services in Irosin, Sorsogon — Aimble I.T. Solutions</title>
    <meta name="description" content="Aimble I.T. Solutions offers custom web development, Maya & GCash integration, virtual assistant services, and walk-in IT shop services in Irosin, Sorsogon." />
    <link rel="canonical" href="https://www.aimbletech.com/services" />
  </Helmet>
  return (
    
    <div style={{ paddingTop: "var(--header-h)" }}>
      {/* ── HEADER ───────────────────────────────────────────────────────── */}
      <Helmet>
        <title>Services - Aimble I.T. Solutions</title>
        <link rel="canonical" href="https://www.aimbletech.com/services" />
      </Helmet>
      <section className="section-sm" style={{ textAlign: "center" }}>
        <div className="container">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}>
            <div className="section-label" style={{ justifyContent: "center" }}>Services</div>
            <h1 className="heading-1">Web Development & IT Services in Irosin, Sorsogon</h1>
            <p className="body-lg text-muted" style={{ maxWidth: 520, margin: "0 auto" }}>
              "Aimble I.T. Solutions is your trusted web developer and IT partner in Irosin, Sorsogon — offering custom website design, payment gateway integration, virtual assistant services, and walk-in tech support for businesses across Bicol Region."
            </p>
          </motion.div>
        </div>
      </section>

      {/* ── WEB DEVELOPMENT ─────────────────────────────────────────────── */}
      <ServiceSection
        label="Digital Services"
        title="Web Development"
        desc="We build custom websites and web applications tailored to your business needs — from landing pages to full enrollment or e-commerce systems."
        icon="🌐"
        items={[
          { title: "Custom Website Design", desc: "Professionally designed, mobile-first websites that represent your brand." },
          { title: "Web Application Development", desc: "React-based web apps with Firebase backend — scalable and maintainable." },
          { title: "E-Commerce & Payment Integration", desc: "Full online store with Maya, GCash, and credit card checkout." },
          { title: "Enrollment Systems", desc: "Student enrollment portals, payment collection, and admin dashboards for schools." },
          { title: "Admin & CMS Panels", desc: "Easy-to-use content management so you can update your own site." },
          { title: "Website Maintenance", desc: "Monthly plans to keep your site fast, secure, and up-to-date." },
        ]}
        cta={{ label: "View Packages", to: "/packages" }}
      />

      {/* ── PAYMENT SOLUTIONS ───────────────────────────────────────────── */}
      <section className="section" style={{ background: "var(--surface)" }}>
        <div className="container">
          <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 64, alignItems: "start" }}>
            <div>
              <div className="section-label">Payment Solutions</div>
              <h2 className="heading-1" style={{ marginBottom: 16 }}>Accept Payments Online — Maya & GCash Integration in Sorsogon</h2>
              <p style={{ color: "var(--text-muted)", marginBottom: 24, lineHeight: 1.7 }}>
                We integrate Maya's official API into your website so your customers can pay with their preferred method. You get the money; we handle the technical setup.
              </p>
              <p style={{ color: "var(--text-muted)", marginBottom: 32, lineHeight: 1.7 }}>
                As a registered Maya Business partner, we can also <strong style={{ color: "var(--text)" }}>process payments on your behalf</strong> — your customers pay through our Maya terminal and we remit the net amount to you after deductions.
              </p>

              <div style={{ marginBottom: 24 }}>
                <h3 style={{ fontSize: "0.875rem", fontWeight: 600, color: "var(--text-muted)", letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 16 }}>Accepted Payment Methods</h3>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {["Maya Wallet", "GCash", "Visa", "Mastercard", "QR Ph", "Installment (3DS)"].map(m => (
                    <span key={m} className="badge badge-blue">{m}</span>
                  ))}
                </div>
              </div>

              <Link to="/packages" className="btn btn-primary">Add Payment Gateway →</Link>
            </div>

            {/* Fee breakdown card */}
            <div>
              <div style={{ background: "var(--navy-mid)", borderRadius: 16, padding: 28, border: "1px solid var(--border-med)" }}>
                <h3 style={{ fontSize: "1rem", fontWeight: 600, marginBottom: 20 }}>Gateway Fee Structure</h3>
                {Object.values(MAYA_FEES).map(fee => (
                  <div key={fee.label} style={{ marginBottom: 20, paddingBottom: 20, borderBottom: "1px solid var(--border)" }}>
                    <div style={{ fontWeight: 600, fontSize: "0.9375rem", marginBottom: 6 }}>{fee.label}</div>
                    <div style={{ fontSize: "0.8125rem", color: fee.total === 0 ? "var(--accent)" : "var(--text-muted)" }}>{fee.description}</div>
                    {fee.total > 0 && (
                      <div style={{ marginTop: 8, display: "flex", gap: 6, flexWrap: "wrap" }}>
                        {fee.birTax > 0 && <span className="badge badge-red">BIR {(fee.birTax * 100).toFixed(0)}%</span>}
                        {fee.mayaFee > 0 && <span className="badge badge-amber">Maya {(fee.mayaFee * 100).toFixed(1)}%</span>}
                        {fee.buffer > 0 && <span className="badge badge-purple">Buffer {(fee.buffer * 100).toFixed(1)}%</span>}
                        <span className="badge badge-blue">Total {(fee.total * 100).toFixed(1)}%</span>
                      </div>
                    )}
                  </div>
                ))}
                <p style={{ fontSize: "0.75rem", color: "var(--text-dim)" }}>
                  * These fees apply only when Aimble processes payments on your behalf through our gateway. If you have your own Maya Business account, standard Maya rates apply.
                </p>
              </div>
            </div>
          </motion.div>

          <style>{`@media(max-width:768px){ .pay-grid { grid-template-columns: 1fr !important; } }`}</style>
        </div>
      </section>

      {/* ── VIRTUAL ASSISTANT ───────────────────────────────────────────── */}
      <ServiceSection
        label="Remote Services"
        title="Virtual Assistant Services"
        desc="Hire a dedicated virtual assistant from our team. We serve both local and international clients — saving you time on repetitive tasks."
        icon="🤝"
        items={[
          { title: "Customer Support", desc: "Email, chat, and social media support for your customers." },
          { title: "Data Entry & Management", desc: "Accurate and organized data processing and management." },
          { title: "Email & Calendar Management", desc: "Keep your inbox and schedule organized and efficient." },
          { title: "Lead Generation", desc: "Find and qualify potential customers for your business." },
          { title: "Social Media Assistance", desc: "Content scheduling, engagement, and reporting." },
          { title: "Bookkeeping Support", desc: "Basic financial record-keeping and expense tracking." },
        ]}
        cta={{ label: "View VA Plans", to: "/packages" }}
      />

      {/* ── SHOP SERVICES ───────────────────────────────────────────────── */}
      <section className="section" style={{ background: "var(--surface)" }}>
        <div className="container">
          <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} style={{ marginBottom: 40 }}>
            <div className="section-label">Walk-In Services</div>
            <h2 className="heading-1" style={{ marginBottom: 16 }}>Walk-In IT Shop in Irosin, Sorsogon</h2>
            <p style={{ color: "var(--text-muted)", maxWidth: 540 }}>
              Our physical shop at Purok 1, Tabon-tabon offers everyday tech and business services for the local community.
            </p>
          </motion.div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 20 }}>
            {SHOP_SERVICES.map((s, i) => (
              <motion.div key={s.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.07 }}>
                <div className="card" style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>
                  <div style={{ fontSize: 28, flexShrink: 0 }}>{s.icon}</div>
                  <div>
                    <h3 style={{ fontSize: "0.9375rem", fontWeight: 600, marginBottom: 4 }}>{s.name}</h3>
                    <p style={{ fontSize: "0.8125rem", color: "var(--text-muted)", lineHeight: 1.5 }}>{s.desc}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} style={{ marginTop: 32, padding: "24px 28px", background: "var(--navy-mid)", borderRadius: 16, border: "1px solid var(--border-med)", display: "flex", gap: 16, alignItems: "center", flexWrap: "wrap" }}>
            <div style={{ fontSize: 24 }}>📍</div>
            <div>
              <div style={{ fontWeight: 600, marginBottom: 2 }}>Our Location</div>
              <div style={{ fontSize: "0.875rem", color: "var(--text-muted)" }}>Purok 1, Tabon-tabon, Irosin, Sorsogon, Philippines</div>
            </div>
            <div style={{ marginLeft: "auto" }}>
              <a href={COMPANY.facebook} target="_blank" rel="noopener noreferrer" className="btn btn-secondary btn-sm">Message on Facebook →</a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}

function ServiceSection({ label, title, desc, icon, items, cta }) {
  return (
    <section className="section">
      <div className="container">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: 64, alignItems: "start" }}>
          <div style={{ position: "sticky", top: "calc(var(--header-h) + 24px)" }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>{icon}</div>
            <div className="section-label">{label}</div>
            <h2 className="heading-1" style={{ marginBottom: 16 }}>{title}</h2>
            <p style={{ color: "var(--text-muted)", lineHeight: 1.7, marginBottom: 24 }}>{desc}</p>
            {cta && <Link to={cta.to} className="btn btn-primary">{cta.label} →</Link>}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
            {items.map((item, i) => (
              <motion.div key={item.title} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.07 }}>
                <div className="card" style={{ height: "100%" }}>
                  <h3 style={{ fontSize: "0.9375rem", fontWeight: 600, marginBottom: 8, color: "var(--accent)" }}>{item.title}</h3>
                  <p style={{ fontSize: "0.875rem", color: "var(--text-muted)", lineHeight: 1.5 }}>{item.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
      <style>{`@media(max-width:768px){.container > div { grid-template-columns: 1fr !important; } .container > div > div:first-child { position: static !important; }}`}</style>
    </section>
  );
}
